function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Clean-design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.01.-Brauk\\u0161anas-nodarb\\u012Bbas---Kopsavilkums",
  transform: "translate(-468.000000, -106.000000)",
  fill: "#C02227"
}, /*#__PURE__*/React.createElement("g", {
  id: "Page-content",
  transform: "translate(270.000000, 30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Blocks",
  transform: "translate(24.000000, 66.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Block-2",
  transform: "translate(164.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Checkmark",
  transform: "translate(10.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z M8.16568542,7.03431458 C7.85326599,6.72189514 7.34673401,6.72189514 7.03431458,7.03431458 C6.72189514,7.34673401 6.72189514,7.85326599 7.03431458,8.16568542 L8.869,10 L7.03431458,11.8343146 C6.72189514,12.146734 6.72189514,12.653266 7.03431458,12.9656854 C7.34673401,13.2781049 7.85326599,13.2781049 8.16568542,12.9656854 L10,11.131 L11.8343146,12.9656854 C12.1183322,13.2497031 12.5627735,13.2755229 12.8759591,13.0431448 L12.9656854,12.9656854 C13.2781049,12.653266 13.2781049,12.146734 12.9656854,11.8343146 L11.131,10 L12.9656854,8.16568542 C13.2781049,7.85326599 13.2781049,7.34673401 12.9656854,7.03431458 C12.653266,6.72189514 12.146734,6.72189514 11.8343146,7.03431458 L10,8.869 L8.16568542,7.03431458 Z",
  id: "icon"
})))))));

function SvgIcError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D14FED8B-4E30-428A-A3CB-A6E3E0F653E8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcError);
export default __webpack_public_path__ + "static/media/ic-error.60fdc3c0.svg";
export { ForwardRef as ReactComponent };